module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "1guarantee.d361dc46.svg";